import type { RacemapEvent } from '@racemap/utilities/types/events';
import { Button } from 'antd';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import { getPlayerUrl } from 'src/lib/getPlayerUrl';
import { IconMap } from '../Icons';

interface Props {
  event: Immutable<RacemapEvent>;
}

export const PlayerLinkButton: FC<Props> = ({ event }) => {
  return (
    <Button
      href={getPlayerUrl(event)}
      target="_blank"
      rel="noopener noreferrer"
      size="small"
      icon={<IconMap fixedWidth />}
    >
      Map
    </Button>
  );
};
